import "./postmedia.scss";
import { usePostMediaLogic } from "./hooks/usePostMediaLogic";
import MediaHeader from "./components/MediaHeader";
import MediaDisplay from "./components/MediaDisplay";
import NavArrow from "./components/NavArrow";

const Postmedia = ({ postId }) => {
    const { state, actions } = usePostMediaLogic(postId);

    if (state.isLoading) return <div className="postmedia">Loading media...</div>;
    if (state.error || !state.mediaList) return <div className="postmedia">Error loading media.</div>;

    return (
        <div 
            className="postmedia"
            onKeyDown={actions.handleKeyDown}
            tabIndex={0}
            autoFocus
        >
            <div className="containerPostMedia">
                <MediaHeader 
                    onClose={actions.handleClose}
                    onZoomIn={actions.handleZoomIn}
                    onZoomOut={actions.handleZoomOut}
                    onReset={actions.handleResetZoom}
                    scale={state.scale}
                />

                <div className="contentPostMedia">
                    <NavArrow 
                        direction="left"
                        visible={state.showNavigation} 
                        onClick={actions.handlePrev} 
                    />

                    <MediaDisplay 
                        file={state.currentFile}
                        index={state.currentIndex}
                        total={state.mediaList.length}
                        scale={state.scale}
                    />

                    <NavArrow 
                        direction="right"
                        visible={state.showNavigation} 
                        onClick={actions.handleNext} 
                    />
                </div>
            </div>
        </div>
    );
};

export default Postmedia;